import React from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'
import { JsonLd } from 'react-schemaorg'

//Import Components
import { BreadcrumbSchema } from '../schema'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const BreadcrumbWrapper = styled.div`
	display: inline-block;
`
const Breadcrumb = styled.div`
	display: inline-block;
	${({ theme }) => theme.fonts.primary};
`
const BreadcrumbDivider = styled.span`
	padding: 0 0.2rem;
	${({ theme }) => theme.MQ.M} {
		padding: 0 10px;
	}
`

Breadcrumbs.propTypes = {
	breadcrumbs: object.isRequired,
}

/**
 * Breadcrumb Component
 * Takes in object of breadcrumb data, displays links for each channel that's provided (usually primary and sub)
 * Also adds Breadcrumb Schema to any page with this component
 *
 * @param {object} breadcrumbs
 */
export function Breadcrumbs({ breadcrumbs }) {
	return (
		<>
			<JsonLd item={BreadcrumbSchema(breadcrumbs)} />
			<Breadcrumb as={Link} aria-label="Home" href="/" variant="breadcrumb">
				Home
			</Breadcrumb>
			{Object.keys(breadcrumbs).map((key) => {
				if (breadcrumbs[key] !== null) {
					const { name, slug } = breadcrumbs[key]
					return (
						<BreadcrumbWrapper key={key}>
							<BreadcrumbDivider>{' > '}</BreadcrumbDivider>
							<Breadcrumb {...(slug && { as: Link, href: `/${slug}/`, variant: 'breadcrumb' })}>
								{name}
							</Breadcrumb>
						</BreadcrumbWrapper>
					)
				}
				return null
			})}
		</>
	)
}
